import type { VoidFunctionComponent } from 'react';

import DetailsPanel from '../../../generic/DetailsPanel';
import DetailsPanelText from '../../../generic/DetailsPanel/DetailsPanelText';
import VulnerabilityDrawerSection from '../../../shared/vulns/Drawer/Section';

/**
 * Stub for the fossabot remediation panel, shown for vulnerability issues when
 * the fossabotDepUpgradePRs flag is on and the user can view fossabot upgrades.
 * For now it renders the collapsible Remediation section with placeholder copy;
 * the real fossabot content lands in CORE-7116.
 */
export const FossabotRemediationPanel: VoidFunctionComponent = () => (
  <VulnerabilityDrawerSection>
    <DetailsPanel id="fossabot-remediation" target="Remediation">
      <div data-testid="fossabot-remediation-panel">
        <DetailsPanelText text="Remediation guidance is coming soon." />
      </div>
    </DetailsPanel>
  </VulnerabilityDrawerSection>
);
